/* unplugin-vue-components disabled */import script from "./Paidversion.vue?vue&type=script&setup=true&name=Paidversion&lang=js"
export * from "./Paidversion.vue?vue&type=script&setup=true&name=Paidversion&lang=js"

import "./Paidversion.vue?vue&type=style&index=0&id=4bcfb2af&lang=scss&scoped=true"

import exportComponent from "E:\\new-admin\\3.0\\ruoyi-vue3-cli\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bcfb2af"]])

export default __exports__